<template>
    <div class="navSection">
        <div class="title-bar" :style="'background-color: ' + item.bgColor.color[0].item + ';'">
            <span :style="'color:' + item.titleColor.color[0].item">{{ item.title }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{

            }
        },
        props:{
            item:{
                type:Object,
                default:{}
            }
        },
    }
</script>

<style scoped lang="scss">
    .title-bar{
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        span{
            font-size: 16px;
            font-weight: 700;
        }
    }

</style>